// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mindmap Section */
.mindmap-section {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mindmap-container {
  width: 100%;
  height: 600px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

/* Error States */
.mindmap-error {
  text-align: center;
  padding: 3rem;
  color: #dc3545;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #f5c6cb;
}

.mindmap-error h3 {
  color: #721c24;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.mindmap-error p {
  color: #721c24;
  margin-bottom: 1.5rem;
  font-size: 1rem;
}

.mindmap-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
}

.generate-mindmap-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  min-width: 180px;
  position: relative;
  overflow: hidden;
}

.generate-mindmap-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.generate-mindmap-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.generate-new-button {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  min-width: 150px;
}

.generate-new-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.generate-new-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.retry-button {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  min-width: 120px;
}

.retry-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

.retry-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}


.no-content p {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.no-content small {
  color: #666;
  font-size: 0.9rem;
  display: block;
  margin-bottom: 1rem;
}

/* Mindmap Content Styling */
.mindmap-container .react-flow {
  background: #f8f9fa;
}

.mindmap-container .react-flow__background {
  background-color: #f8f9fa;
}

.mindmap-container .react-flow__controls {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.mindmap-container .react-flow__controls button {
  background: white;
  border: none;
  border-bottom: 1px solid #e9ecef;
  color: #333;
  font-size: 16px;
  padding: 8px;
  transition: background-color 0.2s ease;
}

.mindmap-container .react-flow__controls button:hover {
  background: #f8f9fa;
}

.mindmap-container .react-flow__controls button:last-child {
  border-bottom: none;
}

/* Node Styling Enhancement */
.mindmap-container .react-flow__node {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.mindmap-container .react-flow__node:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.mindmap-container .react-flow__node.selected {
  box-shadow: 0 0 0 2px #667eea;
}

/* Edge Styling */
.mindmap-container .react-flow__edge-path {
  stroke: #667eea;
  stroke-width: 2;
}

.mindmap-container .react-flow__edge.selected .react-flow__edge-path {
  stroke: #5a6fd8;
  stroke-width: 3;
}

/* Attribution */
.mindmap-container .react-flow__attribution {
  background: rgba(255, 255, 255, 0.8);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  color: #666;
}

/* Zoom Controls */
.mindmap-container .react-flow__controls-zoom {
  display: flex;
  flex-direction: column;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .mindmap-container {
    height: 400px;
    margin: 0 -1rem;
  }
  
  .generate-mindmap-button {
    padding: 0.8rem 1.5rem;
    font-size: 0.95rem;
    min-width: 160px;
  }
  
  .generate-new-button {
    padding: 6px 12px;
    font-size: 13px;
    min-width: 140px;
  }
  
  .retry-button {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
    min-width: 100px;
  }
  
  .mindmap-buttons {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
  }
  
  .no-content {
    padding: 2rem 1rem;
    margin: 0 -1rem;
  }
  
  .mindmap-error {
    padding: 1.5rem 1rem;
    margin: 0 -1rem;
  }
}

@media (max-width: 480px) {
  .mindmap-container {
    height: 300px;
  }
  
  .generate-mindmap-button {
    width: 100%;
    max-width: 280px;
    padding: 0.75rem 1rem;
  }
  
  .generate-new-button {
    width: 100%;
    max-width: 200px;
    padding: 6px 12px;
  }
  
  .retry-button {
    width: 100%;
    max-width: 160px;
    padding: 0.6rem 1rem;
  }
  
  .no-content p {
    font-size: 1rem;
  }
  
  .no-content small {
    font-size: 0.85rem;
  }
}

.generate-mindmap-button:focus,
.generate-new-button:focus,
.retry-button:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

@media (prefers-contrast: high) {
  .mindmap-container {
    border: 2px solid #000;
  }
  
  .mindmap-error {
    border-color: #000;
  }
  
  .no-content {
    border-color: #000;
  }
}

@media (prefers-reduced-motion: reduce) {
  .generate-mindmap-button,
  .generate-new-button,
  .retry-button {
    transition: none;
  }
  
  .mindmap-container .react-flow__node {
    transition: none;
  }
  
  .mindmap-container .react-flow__node:hover {
    transform: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/VideoTabs/MindmapTab.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Mindmap Section */\n.mindmap-section {\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.mindmap-container {\n  width: 100%;\n  height: 600px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px solid #e9ecef;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n/* Error States */\n.mindmap-error {\n  text-align: center;\n  padding: 3rem;\n  color: #dc3545;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px solid #f5c6cb;\n}\n\n.mindmap-error h3 {\n  color: #721c24;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n}\n\n.mindmap-error p {\n  color: #721c24;\n  margin-bottom: 1.5rem;\n  font-size: 1rem;\n}\n\n.mindmap-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.generate-mindmap-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n  min-width: 180px;\n  position: relative;\n  overflow: hidden;\n}\n\n.generate-mindmap-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.generate-mindmap-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.generate-new-button {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n  min-width: 150px;\n}\n\n.generate-new-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);\n}\n\n.generate-new-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.retry-button {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n  min-width: 120px;\n}\n\n.retry-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);\n}\n\n.retry-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n\n.no-content p {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.no-content small {\n  color: #666;\n  font-size: 0.9rem;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n/* Mindmap Content Styling */\n.mindmap-container .react-flow {\n  background: #f8f9fa;\n}\n\n.mindmap-container .react-flow__background {\n  background-color: #f8f9fa;\n}\n\n.mindmap-container .react-flow__controls {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.mindmap-container .react-flow__controls button {\n  background: white;\n  border: none;\n  border-bottom: 1px solid #e9ecef;\n  color: #333;\n  font-size: 16px;\n  padding: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.mindmap-container .react-flow__controls button:hover {\n  background: #f8f9fa;\n}\n\n.mindmap-container .react-flow__controls button:last-child {\n  border-bottom: none;\n}\n\n/* Node Styling Enhancement */\n.mindmap-container .react-flow__node {\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n}\n\n.mindmap-container .react-flow__node:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.mindmap-container .react-flow__node.selected {\n  box-shadow: 0 0 0 2px #667eea;\n}\n\n/* Edge Styling */\n.mindmap-container .react-flow__edge-path {\n  stroke: #667eea;\n  stroke-width: 2;\n}\n\n.mindmap-container .react-flow__edge.selected .react-flow__edge-path {\n  stroke: #5a6fd8;\n  stroke-width: 3;\n}\n\n/* Attribution */\n.mindmap-container .react-flow__attribution {\n  background: rgba(255, 255, 255, 0.8);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  color: #666;\n}\n\n/* Zoom Controls */\n.mindmap-container .react-flow__controls-zoom {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .mindmap-container {\n    height: 400px;\n    margin: 0 -1rem;\n  }\n  \n  .generate-mindmap-button {\n    padding: 0.8rem 1.5rem;\n    font-size: 0.95rem;\n    min-width: 160px;\n  }\n  \n  .generate-new-button {\n    padding: 6px 12px;\n    font-size: 13px;\n    min-width: 140px;\n  }\n  \n  .retry-button {\n    padding: 0.6rem 1.2rem;\n    font-size: 0.9rem;\n    min-width: 100px;\n  }\n  \n  .mindmap-buttons {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n  }\n  \n  .no-content {\n    padding: 2rem 1rem;\n    margin: 0 -1rem;\n  }\n  \n  .mindmap-error {\n    padding: 1.5rem 1rem;\n    margin: 0 -1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .mindmap-container {\n    height: 300px;\n  }\n  \n  .generate-mindmap-button {\n    width: 100%;\n    max-width: 280px;\n    padding: 0.75rem 1rem;\n  }\n  \n  .generate-new-button {\n    width: 100%;\n    max-width: 200px;\n    padding: 6px 12px;\n  }\n  \n  .retry-button {\n    width: 100%;\n    max-width: 160px;\n    padding: 0.6rem 1rem;\n  }\n  \n  .no-content p {\n    font-size: 1rem;\n  }\n  \n  .no-content small {\n    font-size: 0.85rem;\n  }\n}\n\n.generate-mindmap-button:focus,\n.generate-new-button:focus,\n.retry-button:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n@media (prefers-contrast: high) {\n  .mindmap-container {\n    border: 2px solid #000;\n  }\n  \n  .mindmap-error {\n    border-color: #000;\n  }\n  \n  .no-content {\n    border-color: #000;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .generate-mindmap-button,\n  .generate-new-button,\n  .retry-button {\n    transition: none;\n  }\n  \n  .mindmap-container .react-flow__node {\n    transition: none;\n  }\n  \n  .mindmap-container .react-flow__node:hover {\n    transform: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
